module.exports = {
  content: [
    './layout/**/*.liquid',
    './sections/**/*.liquid',
    './snippets/**/*.liquid',
    './templates/**/*.liquid',
    './src/scripts/**/*.js',
    './assets/**/*.js',
  ],
  theme: {
    colors: {
      'tidal-wave': '#5284ED',
      surf: '#CFDCF5',
      sunshine: '#EBC168',
      sand: '#F4EDE2',
      coral: '#EA7359',
      clay: '#EAD8D7',
      slate: '#D9D4CB',
      moss: '#52C07E',
      mint: '#CCE8DB',
      nightfall: '#202124',
      stone: '#6F6F6F',
      transparent: 'transparent',
      black: 'black',
      white: 'white',
      current: 'currentColor',
      success: '#4cc258',
      warning: '#f48e2f',
      error: '#f4522f',
    },
    fontFamily: {
      sans: 'Haffer, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      mono: '"Founders Grotesk Mono", Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace',
    },
    screens: {
      sm: '576px',
      md: '820px',
      lg: '1024px',
      xl: '1280px',
      xxl: '1560px',
    },
    extend: {
      aspectRatio: {
        '21/9': '21 / 9',
      },
      borderRadius: {
        '4xl': '2rem',
      },
      spacing: {
        15: '3.75rem',
      },
      gridTemplateColumns: {
        'flexible-6': 'repeat(6, 1fr)',
        'flexible-12': 'repeat(12, 1fr)',
        13: 'repeat(13, minmax(0, 1fr))',
      },
      maxHeight: {
        112: '28rem',
        128: '32rem',
      },
      zIndex: {
        '-1': '-1',
      },
    },
    debugScreens: {
      position: ['top', 'left'],
    },
  },
  plugins: [
    require('@tailwindcss/forms'),
    require('@tailwindcss/aspect-ratio'),
    require('tailwindcss-debug-screens'),
  ],
};
